module.exports = __webpack_public_path__ + "static/img/13.659841c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/13.png
// module id = VjA6
// module chunks = 0